/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListCars200ResponseMeta } from './ListCars200ResponseMeta';
import {
    ListCars200ResponseMetaFromJSON,
    ListCars200ResponseMetaFromJSONTyped,
    ListCars200ResponseMetaToJSON,
    ListCars200ResponseMetaToJSONTyped,
} from './ListCars200ResponseMeta';
import type { ShowActivity200ResponseDataCar } from './ShowActivity200ResponseDataCar';
import {
    ShowActivity200ResponseDataCarFromJSON,
    ShowActivity200ResponseDataCarFromJSONTyped,
    ShowActivity200ResponseDataCarToJSON,
    ShowActivity200ResponseDataCarToJSONTyped,
} from './ShowActivity200ResponseDataCar';
import type { ListCars200ResponseLinks } from './ListCars200ResponseLinks';
import {
    ListCars200ResponseLinksFromJSON,
    ListCars200ResponseLinksFromJSONTyped,
    ListCars200ResponseLinksToJSON,
    ListCars200ResponseLinksToJSONTyped,
} from './ListCars200ResponseLinks';

/**
 * 
 * @export
 * @interface ListCars200Response
 */
export interface ListCars200Response {
    /**
     * 
     * @type {Array<ShowActivity200ResponseDataCar>}
     * @memberof ListCars200Response
     */
    data?: Array<ShowActivity200ResponseDataCar>;
    /**
     * 
     * @type {ListCars200ResponseLinks}
     * @memberof ListCars200Response
     */
    links?: ListCars200ResponseLinks;
    /**
     * 
     * @type {ListCars200ResponseMeta}
     * @memberof ListCars200Response
     */
    meta?: ListCars200ResponseMeta;
}

/**
 * Check if a given object implements the ListCars200Response interface.
 */
export function instanceOfListCars200Response(value: object): value is ListCars200Response {
    return true;
}

export function ListCars200ResponseFromJSON(json: any): ListCars200Response {
    return ListCars200ResponseFromJSONTyped(json, false);
}

export function ListCars200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListCars200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ShowActivity200ResponseDataCarFromJSON)),
        'links': json['links'] == null ? undefined : ListCars200ResponseLinksFromJSON(json['links']),
        'meta': json['meta'] == null ? undefined : ListCars200ResponseMetaFromJSON(json['meta']),
    };
}

export function ListCars200ResponseToJSON(json: any): ListCars200Response {
    return ListCars200ResponseToJSONTyped(json, false);
}

export function ListCars200ResponseToJSONTyped(value?: ListCars200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ShowActivity200ResponseDataCarToJSON)),
        'links': ListCars200ResponseLinksToJSON(value['links']),
        'meta': ListCars200ResponseMetaToJSON(value['meta']),
    };
}

